<script setup lang="ts">
import ProductItem from "@/views/pages/products/product-item.vue"
import { fetchRecommendProducts } from "@/api/ailoo"
import ProductListItem from "@/views/pages/products/list/product-list-item.vue"

const props = defineProps(
  {
    product: {
      type: Object,
      required: true,
    },
  },
)

const product = ref(props.product)


const { data } = await useFetch("/api/product/recommend", {
  method: "POST",
  key: "product-recommend-" + props.product.id,
  lazy: true,
  server: false,
  body: {
    productId: props.product.id,
    count: 10,
  },
})


//  await fetchRecommendProducts(props.product.id, 10)
const products = computed(() => data?.value || [])


</script>

<template>
  <div class="">
    <div class="">
      <aside class="related algolia-recommended">
        <section
          class="product-list"
          style="--7e560bfa: 2; --32a5b472: 3; --15fff006: 5;"
        >
          <hgroup class="product-list__title">
            <h2 class="section-title">
              Te recomendamos
            </h2>
            <VDivider class="section-divider mb-5" />
          </hgroup>
          <div class="products px-3">
            <ProductListItem
              v-for="prod in products"
              :key="prod.id"
              :product="prod"
            />
          </div>
        </section>
      </aside>
    </div>
  </div>
</template>

<style scoped>
.product-list .products {
  -moz-column-gap: 20px;
  column-gap: 20px;
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(5, 1fr);
  /*grid-template-columns: repeat(var(--7e560bfa), calc(100% / var(--7e560bfa) - 10px));*/
  row-gap: 20px;
}

.button.button--tiny {
  border: 1px solid #000;
  color: #000;
  font-size: 9px !important;
  font-weight: 600;
  line-height: 20px !important;
  padding: 2px 10px;
  text-align: center !important;
}
.product-list .product-list__view-more .button {
  align-items: center;
  background-color: #f5f5f5;
  display: inline-flex;
  justify-content: center;
  min-width: 70px;
}
.product-list .product-list__view-more {
  margin: 40px 0;
  text-align: center;
}

@media only screen and (min-width: 1100px) {
  .product-list .products {
    -moz-column-gap: 10px;
    column-gap: 10px;
    grid-template-columns: repeat(5, 1fr);
   /* grid-template-columns: repeat(var(--15fff006), calc(100% / var(--15fff006) - 24px));*/
    row-gap: 25px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1099px) {
  .product-list .products {
    -moz-column-gap: 10px;
    column-gap: 10px;
    grid-template-columns: repeat(3, 1fr);
    /* grid-template-columns: repeat(var(--15fff006), calc(100% / var(--15fff006) - 24px));*/
    row-gap: 25px;
  }
}

@media only screen and (max-width: 599px) {
  .product-list .products {
    -moz-column-gap: 10px;
    column-gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    /* grid-template-columns: repeat(var(--15fff006), calc(100% / var(--15fff006) - 24px));*/
    row-gap: 25px;
  }
}
</style>

